module.exports = __webpack_public_path__ + "static/media/workcopy.5b588a92.jpg";